import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from './breadcrumb.component';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { TranslationModule } from '../translation/translation.module';
import { BreadcrumbConfig } from './breadcrumb.config';

@NgModule({
    declarations: [BreadcrumbComponent],
    exports: [BreadcrumbComponent],
    imports: [CommonModule, HttpClientModule, RouterModule, MatIconModule, TranslationModule]
})
export class BreadcrumbModule {
    static forRoot(clientConfig?: BreadcrumbConfig): ModuleWithProviders<BreadcrumbModule> {
        const finalConfig = new BreadcrumbConfig();
        if (clientConfig) {
            if (clientConfig.enableUseCaseStatusLogs) finalConfig.enableUseCaseStatusLogs = clientConfig.enableUseCaseStatusLogs;
            if (clientConfig.navigationMenuConfigPath) finalConfig.navigationMenuConfigPath = clientConfig.navigationMenuConfigPath;
        }
        return {
            ngModule: BreadcrumbModule,
            providers: [
                {
                    provide: BreadcrumbConfig,
                    useValue: finalConfig
                }
            ]
        };
    }
}
